export const MasksMixin = {
  data() {
    return {
      einMask: {
        mask: "##-#######",
      },
      ssnMask: {
        mask: "###-##-####",
      },
      phoneMask: {
        mask: "1 ### ### ####",
        eager: true,
      },
      vinCodeMask: {
        mask: "*****************",
      },
      stateShortMask: {
        mask: "@@",
        tokens: {
          "@": {
            pattern: /[a-zA-Z]/,
            transform: (char: string) => char.toUpperCase(),
          },
        },
      },
      yearMask: {
        mask: "####",
      },
      numberMask: {
        mask: "#*",
      },
      timeMask: {
        mask: "A#:MN",
        tokens: {
          A: { pattern: /[0-2]/ },
          M: { pattern: /[0-5]/ },
          N: { pattern: /[0-9]/ },
        },
      },
      zipMask: {
        mask: "*******",
      },
    };
  },
};
